import { render, staticRenderFns } from "./typeModel.vue?vue&type=template&id=81a0f122"
import script from "./typeModel.vue?vue&type=script&lang=js"
export * from "./typeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a0f122')) {
      api.createRecord('81a0f122', component.options)
    } else {
      api.reload('81a0f122', component.options)
    }
    module.hot.accept("./typeModel.vue?vue&type=template&id=81a0f122", function () {
      api.rerender('81a0f122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/typeCustomerManage/typeModel.vue"
export default component.exports